import { ACCOUNT, ACCOUNTBYPHONE, RESPONSEDATA } from "app/shared/services/services-model.type";
import { DataTransferCreate } from "../../reducer/types";
import {
  FETCH_TRANSFER_LOCAL_CREATE_REQUEST,
  FETCH_TRANSFER_LOCAL_CREATE_SUCCESS,
  FETCH_TRANSFER_LOCAL_CREATE_FAILURE,
  FETCH_TRANSFER_LOCAL_CONFIRM_REQUEST,
  FETCH_TRANSFER_LOCAL_CONFIRM_SUCCESS,
  FETCH_TRANSFER_LOCAL_CONFIRM_FAILURE,
  FETCH_TRANSFER_LOCAL_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_LOCAL_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TRANSFER_LOCAL_AUTHORIZATION_KEY_FAILURE,
  SET_TRANSFER_LOCAL_STORE,
  SET_TRANSFER_LOCAL_RESET,
  FETCH_TRANSFER_LOCAL_ACCOUNT_DETAIL_REQUEST,
  FETCH_TRANSFER_LOCAL_ACCOUNT_DETAIL_SUCCESS,
  FETCH_TRANSFER_LOCAL_ACCOUNT_DETAIL_FAILURE,
  FETCH_TRANSFER_LOCAL_MAKE_FEE_REQUEST,
  FETCH_TRANSFER_LOCAL_MAKE_FEE_SUCCESS,
  FETCH_TRANSFER_LOCAL_MAKE_FEE_FAILURE,
  FETCH_TRANSFER_LOCAL_DETAIL_BY_PHONE_REQUEST,
  FETCH_TRANSFER_LOCAL_DETAIL_BY_PHONE_SUCCESS,
  FETCH_TRANSFER_LOCAL_DETAIL_BY_PHONE_FAILURE,
} from "./actions.type";
import {
  FetchTransferLocalCreateRequest,
  FetchTransferLocalCreateSuccess,
  FetchTransferLocalCreateFailure,
  FetchTransferLocalConfirmRequest,
  FetchTransferLocalConfirmSuccess,
  FetchTransferLocalConfirmFailure,
  FetchTransferLocalAuthorizationRequest,
  FetchTransferLocalAuthorizationSuccess,
  FetchTransferLocalAuthorizationFailure,
  SetTransferLocalStore,
  TransferLocalState,
  SetTransferLocalReset,
  FetchTransferLocalAccountDetailRequest,
  FetchTransferLocalAccountDetailSuccess,
  FetchTransferLocalAccountDetailFailure,
  FetchTransferLocalMakeFeeFailure,
  FetchTransferLocalMakeFeeSuccess,
  FetchTransferLocalMakeFeeRequest,
  FetchTransferLocalDetailByPhoneRequest,
  FetchTransferLocalDetailByPhoneSuccess,
  FetchTransferLocalDetailByPhoneFailure,
} from "./types";

// Local
export const fetchTransferLocalCreateRequest = (payload: DataTransferCreate): FetchTransferLocalCreateRequest => ({
  type: FETCH_TRANSFER_LOCAL_CREATE_REQUEST,
  payload,
});

export const fetchTransferLocalCreateSuccess = (payload?: RESPONSEDATA): FetchTransferLocalCreateSuccess => ({
  type: FETCH_TRANSFER_LOCAL_CREATE_SUCCESS,
  payload,
});

export const fetchTransferLocalCreateFailure = (payload?: string): FetchTransferLocalCreateFailure => ({
  type: FETCH_TRANSFER_LOCAL_CREATE_FAILURE,
  payload,
});

export const fetchTransferLocalConfirmRequest = (payload?: RESPONSEDATA): FetchTransferLocalConfirmRequest => ({
  type: FETCH_TRANSFER_LOCAL_CONFIRM_REQUEST,
  payload,
});

export const fetchTransferLocalConfirmSuccess = (payload?: RESPONSEDATA): FetchTransferLocalConfirmSuccess => ({
  type: FETCH_TRANSFER_LOCAL_CONFIRM_SUCCESS,
  payload,
});

export const fetchTransferLocalConfirmFailure = (payload?: string): FetchTransferLocalConfirmFailure => ({
  type: FETCH_TRANSFER_LOCAL_CONFIRM_FAILURE,
  payload,
});

export const fetchTransferLocalAuthorizationRequest = (payload?: RESPONSEDATA, code?: string): FetchTransferLocalAuthorizationRequest => ({
  type: FETCH_TRANSFER_LOCAL_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchTransferLocalAuthorizationSuccess = (payload?: RESPONSEDATA): FetchTransferLocalAuthorizationSuccess => ({
  type: FETCH_TRANSFER_LOCAL_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchTransferLocalAuthorizationFailure = (errorOTP: boolean, payload?: string): FetchTransferLocalAuthorizationFailure => ({
  type: FETCH_TRANSFER_LOCAL_AUTHORIZATION_KEY_FAILURE,
  errorOTP,
  payload,
});

export const setTransferLocalStore = (payload: TransferLocalState): SetTransferLocalStore => ({
  type: SET_TRANSFER_LOCAL_STORE,
  payload,
});

export const setTransferLocalReset = (): SetTransferLocalReset => ({
  type: SET_TRANSFER_LOCAL_RESET,
});

// Transfer Detail Account
export const fetchTransferLocalAccountDetailRequest = (
  payload: ACCOUNT,
  showLoading?: boolean,
): FetchTransferLocalAccountDetailRequest => ({
  type: FETCH_TRANSFER_LOCAL_ACCOUNT_DETAIL_REQUEST,
  payload,
  showLoading,
});

export const fetchTransferLocalAccountDetailSuccess = (payload?: ACCOUNT): FetchTransferLocalAccountDetailSuccess => ({
  type: FETCH_TRANSFER_LOCAL_ACCOUNT_DETAIL_SUCCESS,
  payload,
});

export const fetchTransferLocalAccountDetailFailure = (payload?: string): FetchTransferLocalAccountDetailFailure => ({
  type: FETCH_TRANSFER_LOCAL_ACCOUNT_DETAIL_FAILURE,
  payload,
});

export const fetchTransferLocalDetailByPhoneRequest = (payload: string): FetchTransferLocalDetailByPhoneRequest => ({
  type: FETCH_TRANSFER_LOCAL_DETAIL_BY_PHONE_REQUEST,
  payload,
});

export const fetchTransferLocalDetailByPhoneSuccess = (payload?: ACCOUNTBYPHONE): FetchTransferLocalDetailByPhoneSuccess => ({
  type: FETCH_TRANSFER_LOCAL_DETAIL_BY_PHONE_SUCCESS,
  payload,
});

export const fetchTransferLocalDetailByPhoneFailure = (payload?: string): FetchTransferLocalDetailByPhoneFailure => ({
  type: FETCH_TRANSFER_LOCAL_DETAIL_BY_PHONE_FAILURE,
  payload,
});

// Tính phí
export const fetchTransferLocalMakeFeeRequest = (payload: DataTransferCreate): FetchTransferLocalMakeFeeRequest => ({
  type: FETCH_TRANSFER_LOCAL_MAKE_FEE_REQUEST,
  payload,
});

export const fetchTransferLocalMakeFeeFailure = (payload?: string): FetchTransferLocalMakeFeeFailure => ({
  type: FETCH_TRANSFER_LOCAL_MAKE_FEE_FAILURE,
  payload,
});

export const fetchTransferLocalMakeFeeSuccess = (payload?: RESPONSEDATA): FetchTransferLocalMakeFeeSuccess => ({
  type: FETCH_TRANSFER_LOCAL_MAKE_FEE_SUCCESS,
  payload,
});
